// Inline AJAX submit for the /hello/ intake form.
//
// Posts the form to Formspree as JSON, swaps the form in place for the
// thanks block on success, and shows an inline error on failure. Also
// propagates a ?from=… URL param into the hidden `source` field so the
// /work/ page CTAs can tag their origin without extra forms.
//
// Progressive enhancement: the form has a working native POST as a
// fallback. If JS is disabled or this module fails, submission still
// goes to Formspree, which shows its hosted thank-you page.

export default function coachForm() {
    const form = document.querySelector("[data-coach-form]");
    if (!form) return;

    const submitBtn = form.querySelector("[data-coach-form-submit]");
    const submitLabel = form.querySelector("[data-coach-form-label]");
    const errorEl = form.querySelector("[data-coach-form-error]");
    const thanksEl = document.querySelector("[data-coach-form-thanks]");
    const sourceInput = form.querySelector('input[name="source"]');
    const writeEl = document.querySelector("[data-coach-write]");

    let from = "";
    try {
        from = new URLSearchParams(window.location.search).get("from") || "";
    } catch {
        /* older browsers — leave the defaults */
    }

    // Source tagging: /work/ deep-links use /hello/?from=review#write etc.
    if (sourceInput && from) sourceInput.value = from.slice(0, 40); // defensive cap

    // Coaching is booking-only, so the form ships hidden. Reveal it only
    // for the non-coaching deep-links (review, psychology, hello, plans).
    if (writeEl && from && from !== "coaching") {
        writeEl.hidden = false;
        if (window.location.hash === "#write") {
            // The browser couldn't jump to a hidden target on load.
            writeEl.scrollIntoView({ block: "start" });
        }
    }

    function setError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
    }

    function clearError() {
        if (!errorEl) return;
        errorEl.textContent = "";
        errorEl.hidden = true;
    }

    function setSending(on) {
        if (!submitBtn) return;
        submitBtn.disabled = on;
        if (submitLabel) submitLabel.textContent = on ? "Sending" : "Send it";
    }

    function showThanks() {
        if (!thanksEl) return;
        form.hidden = true;
        thanksEl.hidden = false;
        // Pull the thanks block into view if it rendered off-screen.
        thanksEl.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    form.addEventListener("submit", async (event) => {
        event.preventDefault();
        clearError();
        setSending(true);

        const data = new FormData(form);

        try {
            const response = await fetch(form.action, {
                method: "POST",
                body: data,
                headers: { Accept: "application/json" },
            });

            if (response.ok) {
                showThanks();
                return;
            }

            // Formspree returns structured errors on 4xx.
            let message = "Something broke on the way out. Try again, or email grant@aeromaxteam.com directly.";
            try {
                const body = await response.json();
                if (body && Array.isArray(body.errors) && body.errors.length) {
                    message = body.errors.map((e) => e.message).join(" ");
                }
            } catch {
                /* non-JSON body — use the default message */
            }
            setError(message);
            setSending(false);
        } catch (err) {
            setError("No signal? Check your connection and try again, or email grant@aeromaxteam.com directly.");
            setSending(false);
        }
    });
}
